import { Link } from "react-router-dom";
import ProductCard from "@/components/feature/ProductCard";
import { products as allProducts } from "@/mocks/products";

const featuredSlugs = ["women-basecamp-fleece-200", "basecamp-fleece-200", "traverse-trail-shoe", "summit-32l-pack"];

export default function FeaturedProducts() {
  const products = featuredSlugs
    .map((s) => allProducts.find((p) => p.slug === s))
    .filter(Boolean) as typeof allProducts;

  return (
    <section className="bg-white text-neutral-900 py-12 md:py-16">
      <div className="w-full px-5 md:px-10">
        <div className="flex items-end justify-between mb-8 md:mb-10 flex-wrap gap-4 max-w-[1600px] mx-auto">
          <div>
            <p className="text-[10px] tracking-[0.24em] uppercase text-neutral-500 mb-2">Featured — AW26</p>
            <h2 className="text-[28px] md:text-[32px] leading-[1.12] tracking-[-0.01em] font-light text-neutral-900">
              Season essentials.
            </h2>
          </div>
          <Link
            to="/shop"
            className="text-[13px] text-neutral-700 hover:text-primary-600 flex items-center gap-2 cursor-pointer whitespace-nowrap border-b border-neutral-300 pb-1"
          >
            Shop all essentials <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 md:gap-x-10 gap-y-8 md:gap-y-12 max-w-[1600px] mx-auto" data-product-shop>
          {products.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}